import { create } from 'zustand';
import { Tasks } from '../../api-client/services/v1/TaskService/interfaces';
import serviceInitializer from '../../api-client/configs/serviceInitializer';
import { TaskService } from '../../api-client/services/v1/TaskService';
import { sendSentryData } from '../../../configs/sendSentryData';
import { AsyncState, AsyncStatus, toAppError } from '../../../types';

export interface TasksStoreData {
    tasksState: AsyncState<Tasks>;
    search: (query: string) => Promise<void>;
}

export const useTasksStore = create<TasksStoreData>((set) => {
    const taskServices = serviceInitializer<TaskService>(TaskService);
    let latestQuery = '';

    const search = async (query: string) => {
        const trimmed = query.trim();
        latestQuery = trimmed;

        if (trimmed === '') {
            set({ tasksState: { status: AsyncStatus.IDLE } });
            return;
        }

        set({ tasksState: { status: AsyncStatus.LOADING } });
        try {
            const response = await taskServices.getTasks({ name: trimmed });
            if (latestQuery !== trimmed) return;
            set({ tasksState: { status: AsyncStatus.SUCCESS, data: response.items } });
        } catch (error) {
            if (latestQuery !== trimmed) return;
            console.error(error);
            set({ tasksState: { status: AsyncStatus.ERROR, error: toAppError(error) } });
            sendSentryData({
                message: 'Failed to search tasks',
            });
        }
    };

    return { tasksState: { status: AsyncStatus.IDLE }, search };
});
